module.exports = __webpack_public_path__ + "static/media/gameStart_1.5b0de943.mp3";